import { render, staticRenderFns } from "./BankView.vue?vue&type=template&id=58b9b05a&"
import script from "./BankView.vue?vue&type=script&lang=js&"
export * from "./BankView.vue?vue&type=script&lang=js&"
import style0 from "./BankView.vue?vue&type=style&index=0&id=58b9b05a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports